<template>
  <div class="modal fade" id="AllocationMethodUpdate" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 my-auto">
                <h5 class="modal-title allocation-method-automatic">Switch to Automatic Allocations?</h5>
                <h5 class="modal-title allocation-method-manual">Switch to Manual Allocations?</h5>
              </div>
              <div class="col-3 my-auto">
                <div>
                  <div>
                    <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal"
                          id="closeAllocationMethodUpdate" aria-label="Close"></i></a></span>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body text-center font-weight-bold">
          <div class="allocation-method-manual">
            <p>You are attempting to switch the allocation method for this customer to <b>manual</b>.</p>
            <p>The allocation of any existing transactions will be reset and must be reallocated manually. All
              future transactions will also need to be allocated manually.</p>
            <p><b>Do you wish to proceed?</b></p>
          </div>
          <div class="allocation-method-automatic">
            <p>You are attempting to switch the allocation method for this customer to <b>automatic</b>.</p>
            <p>Any existing transactions will be immediately allocated.</p>
            <p><b>Do you wish to proceed?</b></p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary mx-2" @click="updateAllocationMethod">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.allocation-method--underline {
  text-decoration: underline;
}

.allocation-method-manual,
.allocation-method-automatic {
  display: none;
}

#AllocationMethodUpdate[data-allocation-method='Manual'] .allocation-method-manual {
  display: block;
}

#AllocationMethodUpdate[data-allocation-method='Automatic'] .allocation-method-automatic {
  display: block;
}
</style>

<script>
import Vue from 'vue';
import snotifyHttpError from '@/mixins/snotifyHttpResponses';

export default {
  mixins: [snotifyHttpError],

  data() {
    return {};
  },
  computed: {
    URL() {
      return `https://${Vue.config.honeycomb.moneybot.domain}/api/v1/Accounts`;
    },
    account() {
      return this.$store.state.customers.account;
    }
  },

  methods: {
    allocationMethod() {
      return $('#AllocationMethodUpdate').attr("data-allocation-method")
    },
    updateAllocationMethod() {
      const AllocationMethod = ($('#AllocationMethodUpdate').attr("data-allocation-method"))
      this.$snotify.async(
        'Updating Allocation Method.',
        async () =>
          new Promise((resolve, reject) => {
            this.$http
              .put(
                `${this.URL}/${this.account.Id}`,
                { ...this.account, AllocationMethod },
                { withCredentials: true }
              )
              .then(() => {
                resolve({
                  body: 'Success! Allocation method updated!',
                  config: { closeOnClick: true, timeout: 2000 },
                });
              })
              .catch((error) => {
                this.$store.dispatch('refreshCustomerData');
                reject(this.snotifyHttpError(error));
              })
              .finally(() => $("#AllocationMethodUpdate").modal("hide"));
          })
      );
    },
  },
};
</script>
